function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import YoutubeVideoModalComponent from "components/core/youtube-video-modal/youtube-video-modal-component";
import { YOUTUBE_MODAL_CLOSE_SECONDARY, YOUTUBE_MODAL_OPEN_SECONDARY } from "/constants/bigbrain-event-types";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import VideoPlayCoreButton from "/static/svg/videos/video-play-core-button-v4.svg";
import colors from "/styles/colors";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import { REGULAR_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import ModalWithSignupDefaultProps from "components/core/modal-with-signup/default-props.js";
import { VIDEO_OPTS } from "constants/youtube-modal";
import PlayIcon from "/static/svg/icons/play.svg";
import { withGenericConfig } from "contexts/generic-config-context";
import classnames from "classnames";
import DefaultProps from "./default-props";
import { StyledYouTubePopUpButton } from "./youtube-popup-button.scss";
const MIN_HEIGHT = 546;
const WINDOW_INITIAL_WIDTH = 780;
const WINDOW_INITIAL_HEIGHT = 928;
class YouTubePopUpButton extends PureComponent {
    componentDidMount() {
        this.setState({
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        });
    }
    onPlayButtonClicked() {
        const { videoId } = this.props;
        BigBrain("track", YOUTUBE_MODAL_OPEN_SECONDARY, {
            kind: videoId
        });
        this.setState({
            windowHeight: window.innerHeight - 100,
            windowWidth: window.innerWidth - 100
        }, ()=>this.setState({
                openModal: true
            }));
    }
    closeModal() {
        const { videoId } = this.props;
        BigBrain("track", YOUTUBE_MODAL_CLOSE_SECONDARY, {
            kind: videoId
        });
        this.setState({
            openModal: false
        });
    }
    getVideoIconRenderer(buttonDisplayType) {
        if (buttonDisplayType === REGULAR_BUTTON_TYPE) {
            return /*#__PURE__*/ _jsx("span", {
                role: "button",
                "aria-label": "Video button icon",
                className: classnames("play-wrapper", "regular-button"),
                children: /*#__PURE__*/ _jsx(PlayIcon, {})
            });
        }
        const { iconColor } = this.props;
        return /*#__PURE__*/ _jsx("span", {
            className: "play-wrapper",
            style: {
                color: colors[iconColor]
            },
            children: /*#__PURE__*/ _jsx(VideoPlayCoreButton, {})
        });
    }
    renderButtonComponent() {
        const { buttonSize, buttonDisplayType, buttonText, color, isWithArrow, isWithIcon, isWithIconInsteadOfArrow, outline, minPadding, extraEventData, withoutUnderline } = this.props;
        const buttonProps = {
            buttonSize,
            buttonText,
            isWithArrow,
            color,
            iconRenderer: isWithIcon && (()=>this.getVideoIconRenderer(buttonDisplayType)),
            minPadding,
            onClick: this.onPlayButtonClicked,
            isWithIconInsteadOfArrow,
            outline,
            extraEventData,
            withoutUnderline
        };
        const ButtonComponent = buttonDisplayType === REGULAR_BUTTON_TYPE ? RegularButton : SecondaryButton;
        return /*#__PURE__*/ _jsx(ButtonComponent, _object_spread({}, buttonProps));
    }
    render() {
        const { openModal } = this.state;
        const { videoId } = this.props;
        const videoOpts = this.getVideoOpts();
        const modalStyle = this.getModalStyle();
        return /*#__PURE__*/ _jsxs(StyledYouTubePopUpButton, {
            className: "you-tube-pop-up-button-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "secondary-button-wrapper",
                    tabIndex: 0,
                    onKeyDown: this.onKeyDown,
                    role: "button",
                    children: this.renderButtonComponent()
                }),
                /*#__PURE__*/ _jsx(YoutubeVideoModalComponent, {
                    videoId: videoId,
                    minHeight: MIN_HEIGHT,
                    isOpen: openModal,
                    opts: videoOpts,
                    onCloseModal: this.closeModal,
                    withSignup: false,
                    style: modalStyle
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "getVideoOpts", ()=>{
            const { windowHeight, windowWidth } = this.state;
            const { isMobileOrTabletBrowser } = this.props;
            let videoOpts = _object_spread_props(_object_spread({}, VIDEO_OPTS), {
                height: windowHeight
            });
            if (isMobileOrTabletBrowser) {
                videoOpts = _object_spread_props(_object_spread({}, videoOpts), {
                    width: windowWidth
                });
            }
            return videoOpts;
        });
        _define_property(this, "getModalStyle", ()=>{
            const { isMobileOrTabletBrowser } = this.props;
            const { style } = ModalWithSignupDefaultProps;
            const minWidthProp = isMobileOrTabletBrowser ? {
                minWidth: "unset",
                minHeight: "unset"
            } : {
                minWidth: "960px"
            };
            return _object_spread_props(_object_spread({}, style), {
                content: _object_spread(_object_spread_props(_object_spread({}, style.content), {
                    overflow: "visible"
                }), minWidthProp)
            });
        });
        this.state = {
            openModal: false,
            windowWidth: WINDOW_INITIAL_WIDTH,
            windowHeight: WINDOW_INITIAL_HEIGHT
        };
        this.onPlayButtonClicked = this.onPlayButtonClicked.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.getVideoIconRenderer = this.getVideoIconRenderer.bind(this);
        this.onKeyDown = generateOnKeyDownHandler(this.onPlayButtonClicked);
    }
}
YouTubePopUpButton.defaultProps = DefaultProps;
export default withGenericConfig(YouTubePopUpButton);
